<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-operation"></i> 领域管理</span>
      </div>
      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="一级领域">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入一级领域名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="一级领域" prop="lv1Name"></el-table-column>
        <el-table-column label="二级领域" prop="lv2Name"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="mini"
              @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="deleteDepartment(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑领域' : '新增领域'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentDepartment"
          ref="form"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="一级领域名称" prop="lv1Name">
            <el-input
              v-model="currentDepartment.lv1Name"
              placeholder="请输入一级领域名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="二级领域名称" prop="lv2Name">
            <el-input
              v-model="currentDepartment.lv2Name"
              placeholder="请输入二级领域名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveDepartment">
            {{ isEdit ? "更新" : "确 定" }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { fieldPage, fieldAddOrEdit,fieldDelete } from "@/api/config";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        name: "", // 查询条件
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allData: [],
      tableData: [],
      dialogVisible: false,
      isEdit: false,
      teacherOptions: [], // 管理老师选项
      currentDepartment: {
        lv1Name: "",
        lv2Name: "", // 空间设备号
      },
      rules: {
        lv1Name: [
          { required: true, message: "一级领域名称是必填项", trigger: "blur" },
        ],
        lv2Name: [
          { required: true, message: "二级领域名称是必填项", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleQuery(page) {
      this.currentPage = page || 1;
      const { name } = this.queryParams;
      fieldPage({
        lv1Name: name, // 一级领域名称
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false;
      this.currentDepartment = {
        lv1Name: "",
        lv2Name: "",
      };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.currentDepartment = {
        ...row,
      };
      this.dialogVisible = true;
    },
    saveDepartment() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            lv1Name: this.currentDepartment.lv1Name,
            lv2Name: this.currentDepartment.lv2Name,
          };

          if (this.isEdit) {
            params.id = this.currentDepartment.id; // 编辑时传 id
          }

          fieldAddOrEdit(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery(this.currentPage);
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },

    deleteDepartment(row) {
      console.log(row);
      this.$confirm(`确定删除当前领域:${row.lv1Name} ?`, "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          fieldDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery(this.currentPage);
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
